import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'jquery/dist/jquery.js';
import React, { useEffect, Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import AppRoutes from './AppRoutes';
import { ModalForm } from './components/Common/ModalForm';
import Footer from './components/Layout/Footer';
import { NavMenu } from './components/Layout/NavMenu';
import './custom.css';
import Loader from './components/Common/Loader';



export const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return null;
}
export const App = () => {

    return (
        <>
            <ScrollToTop />
            <ToastContainer position="top-right" newestOnTop={true} />
            <NavMenu />
            <Suspense fallback={<Loader />}>
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, path, ...rest } = route;
                        return <Route key={index} {...rest} element={element} path={path} />;
                    })}
                </Routes>
            </Suspense>
            <Footer />
            <ModalForm />
        </>
    );
}



